const day = 1000 * 60 * 60 * 24;

/**
 * Set newsletter sheet closing time to localstorage
 */
export const setClosed = () => localStorage.setItem('newsletterSheetClosed', `${Date.now()}`);

/**
 * Determine if newsletter sheet has been closed within the last 60 days
 */
export const hasBeenClosed = () => {
  if (typeof localStorage === 'undefined') {
    /* istanbul ignore next line */
    return false;
  }
  // time from localStorage when the use clicked on the close button
  const newsletterSheetClosed = parseInt(localStorage.getItem('newsletterSheetClosed') || '0', 10);
  return newsletterSheetClosed + day * 60 > Date.now();
};
